// Allowed image extensions → MIME type. Browsers often report an empty
// `file.type` for heic/heif/avif, so we resolve the type from the extension
// first and only fall back to the browser's guess.
const EXT_TO_MIME = {
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  png: "image/png",
  webp: "image/webp",
  gif: "image/gif",
  bmp: "image/bmp",
  tiff: "image/tiff",
  tif: "image/tiff",
  avif: "image/avif",
  heic: "image/heic",
  heif: "image/heif",
};

// SKU may contain letters, digits, hyphen and underscore — no spaces.
const SKU_PATTERN = /^[A-Za-z0-9_-]+$/;

const getExtension = (name) => {
  const dot = name.lastIndexOf(".");
  return dot === -1 ? "" : name.slice(dot + 1).toLowerCase();
};

/** MIME type to send as file_type and as the S3 PUT Content-Type. */
export const resolveFileType = (file) =>
  EXT_TO_MIME[getExtension(file.name)] || file.type || "application/octet-stream";

/**
 * Fast client-side mirror of the backend's filename rules, so obviously-bad
 * files are flagged instantly without a round-trip. The backend remains the
 * source of truth and its 400 message is surfaced if it rejects anything.
 * @returns {string|null} an error message, or null when valid.
 */
export const validateSkuFile = (file) => {
  const ext = getExtension(file.name);
  if (!ext || !EXT_TO_MIME[ext]) {
    return "Unsupported type — use jpg, png, webp, gif, bmp, tiff, avif, heic or heif.";
  }
  const sku = file.name.slice(0, file.name.length - ext.length - 1);
  if (!sku || !SKU_PATTERN.test(sku)) {
    return "Name must be the product SKU (letters, digits, - or _) with no spaces.";
  }
  return null;
};
